import React, { useState, useEffect } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import "./Charsooq.css";

const Charsooq = () => {
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pdfPages, setPdfPages] = useState([]);
  const [message, setMessage] = useState("");
  const [firstDate, setFirstDate] = useState("");

  const base_url = "https://khanehyeghtesad.com:8000";

  // Month names in Persian
  const monthNames = [
    "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
    "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"
  ];

  // Optional helper to convert English digits to Persian digits
  const toPersianDigits = (numString) => {
    const persianDigitsMap = {
      "0": "۰",
      "1": "۱",
      "2": "۲",
      "3": "۳",
      "4": "۴",
      "5": "۵",
      "6": "۶",
      "7": "۷",
      "8": "۸",
      "9": "۹",
    };
    return numString.replace(/\d/g, (digit) => persianDigitsMap[digit]);
  };

  // Format a date in YYYYMMDD into "DD MonthName YYYY" in Persian
  const formatShamsiDate = (dateString) => {
    if (!dateString || dateString.length !== 8) return dateString;

    const yearStr = dateString.slice(0, 4);  // e.g. "1403"
    const monthNum = parseInt(dateString.slice(4, 6), 10); // e.g. 11
    const dayStr = dateString.slice(6, 8);   // e.g. "23"

    const persianYear = toPersianDigits(yearStr);
    const persianDay = toPersianDigits(dayStr);
    const persianMonth = monthNames[monthNum - 1] || "";

    // returns "۲۳ بهمن ۱۴۰۳"
    return `${persianDay} ${persianMonth} ${persianYear}`;
  };

  const fetchLatestDate = async () => {
    try {
      const response = await axios.get(`${base_url}/api/newspaper/last-date/`);
      const latestDate = response.data.latest_shamsi_date.toString();
      setYear(latestDate.slice(0, 4));
      setMonth(latestDate.slice(4, 6));
      setDay(latestDate.slice(6, 8));
    } catch (error) {
      console.error("Error fetching latest date:", error);
    }
  };

  const fetchFirstDate = async () => {
    try {
      const response = await axios.get(`${base_url}/api/newspaper/first-date/`);
      setFirstDate(response.data.first_shamsi_date.toString()); 
    } catch (error) {
      console.error("Error fetching first date:", error);
    }
  };

  const fetchPdfPage = async (page = 1) => {
    setLoading(true);

    const paddedMonth = month.padStart(2, "0");
    const paddedDay = day.padStart(2, "0");
    const date = `${year}${paddedMonth}${paddedDay}`;

    // Compare selected date to first available date
    if (firstDate && date < firstDate) {
      setMessage(`کاربر گرامی، روزنامه‌های ما از تاریخ ${formatShamsiDate(firstDate)} به بعد در دسترس هستند.`);
      setLoading(false);
      setPdfPages([]);
      return;
    }

    try {
      const response = await axios.get(`${base_url}/api/newspaper/${date}/`, {
        params: { page },
      });
      const newPdfPages = [...pdfPages];
      newPdfPages[page - 1] = response.data[`page${page}`];
      setPdfPages(newPdfPages);
      setMessage("");
    } catch (error) {
      console.error("Error fetching PDF page:", error);
      setMessage("در این تاریخ روزنامه‌ای یافت نشد.");
      setPdfPages([]);
    }
    setLoading(false);
  };

  const generateSinglePagePDF = () => {
    const doc = new jsPDF();
    const imgData = `data:image/jpeg;base64,${pdfPages[currentPage - 1]}`;

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const ratio = Math.min(pageWidth / 210, pageHeight / 297); 
    const imgWidth = 210 * ratio;
    const imgHeight = 297 * ratio;

    doc.addImage(
      imgData,
      "JPEG",
      (pageWidth - imgWidth) / 2,
      (pageHeight - imgHeight) / 2,
      imgWidth,
      imgHeight
    );

    doc.save(`newspaper-page-${currentPage}.pdf`);
  };

  const generateAllPagesPDF = async () => {
    setDownloading(true);

    const paddedMonth = month.padStart(2, "0");
    const paddedDay = day.padStart(2, "0");
    const date = `${year}${paddedMonth}${paddedDay}`;

    try {
      const response = await axios.get(`${base_url}/api/newspaper/${date}/`);
      const newPdfPages = [];
      for (let i = 1; i <= 8; i++) {
        if (response.data[`page${i}`]) {
          newPdfPages.push(response.data[`page${i}`]);
        } else {
          setMessage("در این تاریخ برخی صفحات یافت نشد.");
          setDownloading(false);
          return;
        }
      }

      const doc = new jsPDF();
      newPdfPages.forEach((page, index) => {
        const imgData = `data:image/jpeg;base64,${page}`;
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const ratio = Math.min(pageWidth / 210, pageHeight / 297); 
        const imgWidth = 210 * ratio;
        const imgHeight = 297 * ratio;

        if (index > 0) {
          doc.addPage();
        }
        doc.addImage(
          imgData,
          "JPEG",
          (pageWidth - imgWidth) / 2,
          (pageHeight - imgHeight) / 2,
          imgWidth,
          imgHeight
        );
      });

      doc.save(`newspaper-${date}-all-pages.pdf`);
      setDownloading(false);
    } catch (error) {
      console.error("Error fetching all pages:", error);
      setMessage("در این تاریخ روزنامه‌ای یافت نشد.");
      setDownloading(false);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchPdfPage(pageNumber);
  };

  useEffect(() => {
    fetchLatestDate();
    fetchFirstDate();
  }, []);

  useEffect(() => {
    if (month && day && year) {
      setCurrentPage(1);
      fetchPdfPage();
    }
  }, [month, day, year]);

  return (
    <div className="charsooq-page">
      <header className="charsooq-header">
        <h1>روزنامه چارسوق</h1>
      </header>

      <div className="date-selector">
        <select value={day} onChange={e => setDay(e.target.value)}>
          <option value="">{day || "4"}</option>
          {Array.from({ length: 31 }, (_, i) => (
            <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
              {i + 1}
            </option>
          ))}
        </select>

        <select value={month} onChange={e => setMonth(e.target.value)}>
          <option value="">
            {monthNames[parseInt(month) - 1] || "اسفند"}
          </option>
          {monthNames.map((monthName, index) => (
            <option key={index + 1} value={String(index + 1).padStart(2, "0")}>
              {monthName}
            </option>
          ))}
        </select>

        <select value={year} onChange={e => setYear(e.target.value)}>
          <option value="">{year || "1403"}</option>
          <option value="1403">1403</option>
          <option value="1404">1404</option>
        </select>

        <button onClick={() => fetchPdfPage(1)}>جستجو</button>
      </div>

      {message && (
        <div className="message-container">
          <p>{message}</p>
        </div>
      )}

      <div className="download-btns-container">
        <button className="download-btn" onClick={generateSinglePagePDF}>
          دانلود صفحه {currentPage} به عنوان PDF
        </button>
        <button className="download-btn" onClick={generateAllPagesPDF}>
          {downloading ? "در حال دانلود..." : "دانلود همه صفحات به عنوان PDF"}
        </button>
      </div>

      {loading ? (
        <p>در حال بارگذاری...</p>
      ) : (
        <div className="pdf-page">
          {pdfPages[currentPage - 1] && (
            <img
              src={`data:image/jpeg;base64,${pdfPages[currentPage - 1]}`}
              alt={`Page ${currentPage}`}
              className="pdf-image"
            />
          )}
        </div>
      )}

      <div className="pagination">
        {Array.from({ length: 8 }, (_, i) => (
          <button
            key={i + 1}
            className={currentPage === i + 1 ? "active" : ""}
            onClick={() => handlePageClick(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Charsooq;
